import React from "react";
import "../styles/_prices.scss";
interface Props {}

const Prices: React.FC<Props> = (props) => {
  return (
    <div className="Prices padding100" id="price">
      <div className="container">
        <div className="row flex-column flex-lg-row">
          <div className="col-12 col-lg-6  mb-3 mb-md-0">
            <h6 className="text-start">AL-MARE</h6>
            <h1 className="text-start">PRICES</h1>
            <table className="table  ">
              <thead>
                <tr>
                  <th scope="col" className="text-white ">
                    Period
                  </th>
                  <th scope="col" className="text-white text-center">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-start ">20.05.2025 – 31.05.2025</td>
                  <td className="text-center">115.00 €</td>
                </tr>
                <tr>
                  <td className="text-start ">01.06.2025 – 10.06.2025</td>
                  <td className="text-center">130.00 €</td>
                </tr>
                <tr>
                  <td className="text-start ">11.06.2025 – 30.06.2025</td>
                  <td className="text-center">160.00 €</td>
                </tr>
                <tr>
                  <td className="text-start ">01.07.2025 – 19.07.2025</td>
                  <td className="text-center">180.00 €</td>
                </tr>
                <tr>
                  <td className="text-start ">20.07.2025 – 31.08.2025</td>
                  <td className="text-center">190.00 €</td>
                </tr>
                <tr>
                  <td className="text-start ">01.09.2025 – 09.09.2025</td>
                  <td className="text-center">155.00 €</td>
                </tr>
                <tr>
                  <td className="text-start ">10.09.2025 – 20.09.2025</td>
                  <td className="text-center">145.00 €</td>
                </tr>
                <tr>
                  <td className="text-start ">21.09.2025 – 30.09.2025</td>
                  <td className="text-center">135.00 €</td>
                </tr>
              </tbody>
            </table>
            <ul>
              <li>
                The price is are for two people HB / breakfast and dinner /
              </li>
              <li>Third adult person pays 70% from half of the price</li>
              <li>Baby 0-1.99 is free of charge / baby cot on request /</li>
              <li>
                First child under 13.99 years is free of charge on extra bed
                with two adults in ½ room{" "}
              </li>
              <li>Second child pays 60% from half of the price</li>
              <li>
                For SV rooms there is extra charge of 10.00 € per day / on
                request /{" "}
              </li>
              <li>
                For SSV rooms there is extra charge of 5.00 € per day / on
                request /
              </li>
              <li>Minimum stay is 5 overnights</li>
              <li>Pets are allowed</li>
              <li>
                Confirmation only on request on mail{" "}
                <span
                  className="mailSending"
                  onClick={(e) => {
                    window.location.href = "mailto:info.almare@gmail.com";
                  }}
                >
                  info.almare@gmail.com
                </span>
              </li>
              <li>Daily residence tax is 5.00 € per day per room</li>
            </ul>
            <br />
            <h3>CAPACITY IN THE ROOMS</h3>
            <br />
            <table className="table  ">
              <thead>
                <tr>
                  <th scope="col" className="text-white "></th>
                  <th scope="col" className="text-white text-center">
                    MIN
                  </th>
                  <th scope="col" className="text-white text-center">
                    MAX
                  </th>
                  <th scope="col" className="text-white text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-start ">¼</td>
                  <td className="text-center">3 adults </td>
                  <td className="text-center">3 adults + 2 children</td>
                  <td className="text-center">2 adults + 3 children</td>
                </tr>
                <tr>
                  <td className="text-start ">1/3 </td>
                  <td className="text-center">3 adults</td>
                  <td className="text-center">2 adults + 2 children / extra bed /</td>
                  <td className="text-center">2 adults + 1 children + baby</td>
                </tr>
                <tr>
                  <td className="text-start ">½ </td>
                  <td className="text-center">2 adults</td>
                  <td className="text-center">2 adults + 1 children / extra bed /</td>
                  <td className="text-center">2 adults + 1 children + baby </td>
                </tr>
              </tbody>
            </table>
            <br />
          </div>
          <div className="col-12 col-lg-6">
            <img src="priceImg.jpg " alt="" className="w-100 mb-5" />
            <h3>PAYMENT POLICY</h3>
            <br />
            <p>
              Changes and cancellations up to 15 days prior to arrival: <br />
              • the full amount shall be refunded. <br />
              <br />
              Changes and cancellations / full or particular / 10 – 14 days
              prior to arrival: <br />
              • 50% of the amount of canceled period shall be refunded. <br />
              <br />
              Changes and cancellations / full or partial / 10 or less day prior
              arrival, no show or early departure: <br />
              • the full amount shall be withheld by the hotel. <br /> <br />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Prices;
